module.exports = __webpack_public_path__ + "static/media/Clock_project.f90e8734.jpg";